export default "__VITE_ASSET__BgWHPNYp__"